import { Text, View } from '@react-pdf/renderer';

// Utils
import { isEmptyValueArray } from '@shared/utils';
import { buildEducationLine } from '@/utils/resume';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/AgilityIO/tokens';

// Types
import { FormEducation } from '@shared/types';

// Styles
import styles from '../style';
interface EducationSectionProps {
  educations: FormEducation[];
}
const EducationSection = ({
  educations
}: EducationSectionProps) => {
  if (!educations || isEmptyValueArray(educations)) return null;
  return <View style={styles.section} data-sentry-element="View" data-sentry-component="EducationSection" data-sentry-source-file="Education.tsx">
      <Text style={styles.sectionHeading} data-sentry-element="Text" data-sentry-source-file="Education.tsx">{SECTION_TITLES.education}</Text>

      {educations.map((education, eduIdx) => {
      const {
        id = '',
        school = '',
        graduation = '',
        degree = '',
        major = ''
      } = education || {};
      const educationLine = buildEducationLine(school, degree, major, graduation);
      if (!educationLine) return null;
      return <Text key={`edu-${id}-${eduIdx}`} style={styles.entryLine}>
            {educationLine}
          </Text>;
    })}
    </View>;
};
export default EducationSection;